import { Player, Youtube, DefaultUi } from '@vime/react';
import '@vime/core/themes/default.css';
import VimeoSdk from 'components/VimeoSdk/VimeoSdk';

interface VideoPlayerProps {
  url: string;
  poster: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ url, poster }) => {

  const getVideoSource = (url: string) => {
    try {
      const parsedUrl = new URL(url);

      if (parsedUrl.hostname.includes('youtube.com') || parsedUrl.hostname.includes('youtu.be')) {
        let videoId = '';
        if (parsedUrl.pathname.includes('/embed/')) {
          videoId = parsedUrl.pathname.split('/embed/')[1];
        } else if (parsedUrl.searchParams.get('v')) {
          videoId = parsedUrl.searchParams.get('v')!;
        } else {
          videoId = parsedUrl.pathname.replace('/', '');
        }
        return { type: 'youtube' as const, videoId };
      }

      if (parsedUrl.hostname.includes('vimeo.com')) {
        const videoId = parsedUrl.pathname.split('/').pop()!;
        return { type: 'vimeo' as const, videoId };
      }

      return { type: 'unknown' as const, videoId: null };
    } catch {
      if (/^\d+$/.test(url)) {
        return { type: 'vimeo' as const, videoId: url };
      }
      return { type: 'youtube' as const, videoId: url };
    }
  };

  const { type, videoId } = getVideoSource(url);

  if (!videoId) return <div>Video não suportado</div>;

  return (
  <div className="relative w-full aspect-video">
    {type === 'youtube' && (
      <Player>
        <Youtube videoId={videoId} />
        <DefaultUi />
      </Player>
    )}

    {type === 'vimeo' && (
      <VimeoSdk videoId={videoId} />
    )}
  </div>
);
};

export default VideoPlayer;
